import { LitElement, css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
interface Item {
    description: string;
    amount: number;
    unit: "euro" | "MWh";
}

const currencyFormatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
});

@customElement("c-financial-statistics")
export class FinancialStatisticsWidget extends LitElement {
    static styles = css`
        :host {
            display: block;
            height: 100%;
            container: widget / size;
            margin-left: 2rem;
            margin-right: 2rem;
        }

        p {
            display: flex;
            justify-content: space-between;
        }

        @container (height < 390px) {
            div {
                font-size: 0.6em;
            }
        }

        @container (height >= 200px) and (height < 300px) {
            div {
                font-size: 0.8em;
            }
        }

        @container (height >= 300px) and (height < 390px) {
            div {
                font-size: 1em;
            }
        }
    `;

    @state()
    items: Item[] = [];

    @state()
    qasWithManualFlag: number = 0;

    async connectedCallback() {
        super.connectedCallback();

        this.items = [
            {
                description: "B2C Settlements - total unpaid to end user",
                amount: 123456,
                unit: "euro",
            },
            {
                description: "B2C Settlements - total unpaid to partner",
                amount: 23456,
                unit: "euro",
            },
            {
                description:
                    "B2C Settlements - total assigned value to single deals",
                amount: 230000,
                unit: "euro",
            },
            {
                description:
                    "B2C Settlements - total assigned value to profit shares",
                amount: 114000,
                unit: "euro",
            },
            {
                description:
                    "B2C Settlements - total MWh certified & unassigned",
                amount: 2023,
                unit: "MWh",
            },
        ];
    }

    MWhTemplate(item: Item) {
        return html`<p>
            ${item.description}: <span>${item.amount} ${item.unit}</span>
        </p>`;
    }

    currencyTemplate(item: Item) {
        return html`<p>
            ${item.description}:
            <span>${currencyFormatter.format(item.amount)}</span>
        </p>`;
    }

    render() {
        return html`<div>
            <h1>Financial Statistics</h1>
            ${this.items.map((item) =>
                item.unit === "euro"
                    ? this.currencyTemplate(item)
                    : this.MWhTemplate(item)
            )}
        </div>`;
    }
}
